import script from "./PermissionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionManagement.vue?vue&type=script&setup=true&lang=js"

import "./PermissionManagement.vue?vue&type=style&index=0&id=bf4cf8c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4cf8c2"]])

export default __exports__